(function() {
/* jshint ignore:start */

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);

// http://www.paulirish.com/2009/throttled-smartresize-jquery-event-handler/
!function(n,r){var t=function(n,r,t){var e;return function(){function i(){t||n.apply(u,a),e=null}var u=this,a=arguments;e?clearTimeout(e):t&&n.apply(u,a),e=setTimeout(i,r||100)}};jQuery.fn[r]=function(n){return n?this.bind("resize",t(n)):this.trigger(r)}}(jQuery,"smartresize");

/*! js-cookie v3.0.0-beta.4 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var r=e.Cookies,n=e.Cookies=t();n.noConflict=function(){return e.Cookies=r,n}}())}(this,function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)e[n]=r[n]}return e}var t={read:function(e){return e.replace(/%3B/g,";")},write:function(e){return e.replace(/;/g,"%3B")}};return function r(n,i){function o(r,o,u){if("undefined"!=typeof document){"number"==typeof(u=e({},i,u)).expires&&(u.expires=new Date(Date.now()+864e5*u.expires)),u.expires&&(u.expires=u.expires.toUTCString()),r=t.write(r).replace(/=/g,"%3D"),o=n.write(String(o),r);var c="";for(var f in u)u[f]&&(c+="; "+f,!0!==u[f]&&(c+="="+u[f].split(";")[0]));return document.cookie=r+"="+o+c}}return Object.create({set:o,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var r=document.cookie?document.cookie.split("; "):[],i={},o=0;o<r.length;o++){var u=r[o].split("="),c=u.slice(1).join("="),f=t.read(u[0]).replace(/%3D/g,"=");if(i[f]=n.read(c,f),e===f)break}return e?i[e]:i}},remove:function(t,r){o(t,"",e({},r,{expires:-1}))},withAttributes:function(t){return r(this.converter,e({},this.attributes,t))},withConverter:function(t){return r(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(i)},converter:{value:Object.freeze(n)}})}(t,{path:"/"})});

/* jshint ignore:end */
})();

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {



        const jsCookieAccept = function(){
          // ######################################## COOKIE EVENT
          // this is my cookie events

          //console.log(Cookies + 'asdsdfadsf');

          const html = document.querySelector('html');
          //Cookies.remove('acceptclarkwilsoncookie');
          var cookieWrapper = document.querySelector('.js--cookie-notification');
          if( cookieWrapper ){
            var acceptButton = cookieWrapper.querySelector('.accept');
            var closeButton = cookieWrapper.querySelector('.close');
            html.classList.add('is--cookie__notaccepted');
            acceptButton.addEventListener('click',function(e){
              Cookies.set('acceptclarkwilsoncookie', '1', { expires: 7200 });
              //html.classList.add('is--cookie__accepted');
              html.classList.remove('is--cookie__notaccepted');
            });

            closeButton.addEventListener('click',function(e){
              Cookies.set('acceptclarkwilsoncookie', '1', { expires: 7200 });
              //html.classList.add('is--cookie__accepted');
              html.classList.remove('is--cookie__notaccepted');
            });


            if( Cookies.get('acceptclarkwilsoncookie') === '1' ){
              //html.classList.add('is--cookie__accepted');
              html.classList.remove('is--cookie__notaccepted');
            }else{
              //html.classList.remove('is--cookie__accepted');
              html.classList.add('is--cookie__notaccepted');
            }
          }
        };
        jsCookieAccept();




        // JavaScript to be fired on all pages
        var toggles = document.querySelectorAll(".mobile-nav-toggle");


        var getQueryString = function ( field, url ) {
            var href = url ? url : window.location.href;
            var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
            var string = reg.exec(href);
            return string ? string[1] : null;
        };

        function toggleHandler(toggle) {
          toggle.addEventListener( "click", function(e) {
            e.preventDefault();
            if (this.classList.contains('is-active') === true) {
              this.classList.remove('is-active');
              $('.cover').removeClass('is-active');
            } else {
              this.classList.add('is-active');
              $('.cover').addClass('is-active');
            }
            $('.nav-primary').toggle();
          });
        }

        for (var i = toggles.length - 1; i >= 0; i--) {
          var toggle = toggles[i];
          toggleHandler(toggle);
        }

        $('li.menu-item-has-children>a').each(function() {
          $(this).append('<svg class="CW-triangle"><use xlink:href="#CW-triangle"></use></svg>');
        });

        var window_w;
        window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if(window_w > 959) {
          $('li.menu-item-has-children').hover(
            function() {
              $('.cover').addClass('is-active');
            },
            function() {
              $('.cover').removeClass('is-active');
            }
          );
        }

        $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {
          // Prevent default anchor event
          e.preventDefault();

          // Set values for window
          intWidth = intWidth || '500';
          intHeight = intHeight || '400';
          strResize = (blnResize ? 'yes' : 'no');

          // Set title and open popup with focus on it
          var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
              strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
              objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
        };

        $(document).ready(function ($) {
          $('.share.client').on("click", function(e) {
            $(this).customerPopup(e);
          });
        });

        $('.slideshow').slick({
          prevArrow: '<svg class="CW-chev prev"><use xlink:href="#CW-chev"></use></svg>',
          nextArrow: '<svg class="CW-chev next"><use xlink:href="#CW-chev"></use></svg>',
          dots: true,
          autoplay: true,
          autoplaySpeed: 6000
        });

        if($('.main .container').children().last().is('.culture')) {
          $('footer').addClass('no-margin');
        }

        if($('.main').children().last().is('.callout')) {
          $('footer').addClass('no-margin');
        }

        /* Every time the window is scrolled ... */
        var bottom_of_object, bottom_of_window;
        var is_mobile;
        if ($('html').hasClass('touchevents')) {
          is_mobile = true;
        } else {
          is_mobile = false;
        }

        $(window).scroll( function(){
          /* Check the location of each desired element */
          $('.hideme').each( function(i){
            if (is_mobile) {
              // fade in sooner on mobile
              bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.15;
            } else {
              bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.4;
            }

            bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if(bottom_of_window > bottom_of_object) {
              $(this).animate({'opacity':'1'},600);
            }
          });
        }).trigger('scroll');

        $(window).scroll( function(){
          /* Check the location of each desired element */
          $('.shortcode.culture.fade').each( function(i){
            bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.6;
            bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if(bottom_of_window > bottom_of_object) {
              $(this).find('.content-wrapper').addClass('active');
            }
          });
        }).trigger('scroll');

        var count;

        $(window).on('scroll', function(){
          $('.count').each(function (i) {
            count = $(this).data('count');
            bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.3;
            bottom_of_window = $(window).scrollTop() + $(window).height();

            if (bottom_of_window > bottom_of_object && count === true) {

              $(this).countTo({
                speed: 4000,
                refreshInterval: 20
              });

              $(this).data('count', false);

            }

          });
        }).trigger('scroll');

        // Slick for quote show
        (function() {
          // setup loop
          var scroll = window.requestAnimationFrame ||
                       window.webkitRequestAnimationFrame ||
                       window.mozRequestAnimationFrame ||
                       window.msRequestAnimationFrame ||
                       window.oRequestAnimationFrame ||
                       // IE Fallback, you can even fallback to onscroll
                       function(callback) { window.setTimeout(callback, 1000/60); };
          var distanceY = 0,
              lastPosition = -1;

          // setup triggerSlick
          var $quoteshow = $('.quoteshow');
          var quoteshow_top = 0;
          var trigger_point = window.innerHeight * 0.9;
          var slick_started = false;

          function triggerSlick() {
            $quoteshow.slick({
              prevArrow: '<svg class="CW-chev prev"><use xlink:href="#CW-chev"></use></svg>',
              nextArrow: '<svg class="CW-chev next"><use xlink:href="#CW-chev"></use></svg>',
              dots: true,
              autoplay: true,
              autoplaySpeed: 5000
            });
          }
          function callSlickOnMobile() {
            quoteshow_top = $quoteshow[0].getBoundingClientRect().top;
            if (quoteshow_top < trigger_point) {
              if ($quoteshow.is(':visible') && !slick_started) {
                triggerSlick();
                slick_started = true;
              }
            }
          }

          // loop
          var loop = function() {

            distanceY = window.pageYOffset || document.documentElement.scrollTop;

            // prevent calculation if not scrolled
            if (lastPosition === distanceY) {
              scroll(loop);
              return false;
            } else {
              lastPosition = distanceY;
            }

            callSlickOnMobile();

            if (slick_started) {
              return false;
            }

            scroll(loop);

          };

          // call function
          if ($('.quoteshow').is(':visible')) {
            loop();
          }

        }());



        // Click event on #footnote
        // When user is not in #tab_profile, change hash and invoke hashchange event below
        var hash_changed_by_footnote = false;
        var $footnote;
        $('a[href="#footnote"]').on('click', function(e) {
          e.preventDefault();

          var $profile_tab = $(this).attr('data-profile-tab');
          if (window.location.hash !== $profile_tab) {
            hash_changed_by_footnote = true;
            window.location.hash = $profile_tab;
          } else {
            $footnote = $('[name="footnote"]');
            if ($footnote.length > 0) {
              $('html, body').animate({
                scrollTop: $footnote.offset().top
              }, 300);
              return false;
            }
          }
        });
        // Tab switch on hashchange
        $(window).on('hashchange', function() {
          if(window.location.hash !== '') {
            var hash_id = document.location.hash.replace('tab_', '');
            var id = hash_id.replace('#', '');

            var root = $('html, body');

            // if called by #footnote click
            if (hash_changed_by_footnote) {
              hash_changed_by_footnote = false;
              
              $('ul.tabs li').removeClass('current');
              $("ul").find("[data-tab='" + id + "']").addClass('current');
              $('.tab-content').removeClass('current');
              $(hash_id).addClass('current');

              $footnote = $('[name="footnote"]');
              if ($footnote.length > 0) {
                $('html, body').animate({
                  scrollTop: $footnote.offset().top
                }, 300);
                return false;
              }

            } else {
              // usual tab switch
              var scroll_amount;
              if ($(window).width() < 960) {
                // on mobile, need to get tabs position since tab-link is set to display: none
                scroll_amount = $('ul.tabs').offset().top - 60;
              } else {
                scroll_amount = $('[name=' + id +']').offset().top - 60;
              }

              root.animate({
                scrollTop: scroll_amount
              }, 300);

              $('ul.tabs li').removeClass('current');
              $("ul").find("[data-tab='" + id + "']").addClass('current');
              $('.tab-content').removeClass('current pointer-e-auto');
              var $hash_id_el = $(hash_id);
              $hash_id_el.addClass('current');
              $hash_id_el.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(e) {
                $hash_id_el.addClass('pointer-e-auto');
              });
            }
          }
        }).trigger('hashchange');

        var currentLang = getQueryString('lang');
        if( currentLang ){
          $('.single-people-article').hide();
          $('.single-people-article#'+currentLang).show();
        }


        $('ul.tabs li').on('click', function() {
          var tab_id = $(this).attr('data-tab');
          //var lang = $('.single-people-article').data('lang');
          window.location.hash = 'tab_' + tab_id;

          if ($(window).width() < 960) {
            $('ul.tabs li').parent().prepend(this);
            $('ul.tabs li').not(':first-child').toggle();
          }
        });
        // when clicking the link to work highlights in profile content
        var $cache_tab_links = $('ul.tabs li');
        var $cache_work_li = $('ul.tabs').find("[data-tab='work_highlights']");
        $('.link-work-highlights-tab').on('click', function() {
          if ($(window).width() < 960) {
            $cache_tab_links.hide();
            $cache_work_li.toggle();
          }
        });

        // Set max length of characters in excerpt
        // Remove characters if the container height is over max height
        function removeOverflowText($obj, max_height) {
          $obj.each(function() {
            var $target = $(this);
            var $post_img = $target.prev('.wp-post-image');

            var max_texts_h;
            var diff;
            var line_h = 24;
            var chara_per_line;
            var lines;
            var $entry_summary_p;
            var curr_text;
            var new_text;

            if ($post_img.length > 0) {
              max_texts_h = max_height - $post_img.outerHeight();

              diff = $target.outerHeight() - max_texts_h;

              // 17 for balancing title and description
              chara_per_line = 17;
              if (diff > 0) {

                // 10 for header's margin
                lines = Math.ceil((max_texts_h - 10) / line_h);
                //console.log(lines * chara_per_line);

                $entry_summary_p = $target.find('.entry-summary p');
                curr_text = $entry_summary_p.text();

                new_text = curr_text.substr(0, lines * chara_per_line);
                $entry_summary_p.text(new_text + ' ... Continued');
              }

            } else {
              // content is title and description

              max_texts_h = max_height;
              $entry_summary_p = $target.find('.entry-summary p');
              var title_h = $target.find('.entry-title').outerHeight();

              content_h = title_h + $entry_summary_p.outerHeight();
              diff = content_h - max_texts_h;

              chara_per_line = 20;
              if (content_h > max_texts_h) {

                // 18 for header's margin
                lines = Math.ceil((max_texts_h - title_h - 18) / line_h);

                curr_text = $entry_summary_p.text();

                new_text = curr_text.substr(0, lines * chara_per_line);
                $entry_summary_p.text(new_text + ' ... Continued');
              }
            }

          });
        }

        $body = $('body');
        $(window).on('load', function() {
          if ($body.hasClass('blog') ||
              $body.hasClass('search') ||
              $body.hasClass('archive') ||
              $body.hasClass('home')) {
            //var header_max_height = 365; // max height not to touch meta info
            var post_max_height = 350; // max height not to touch meta info
            var $post_content = $('.type-post header');

            if ($post_content.length > 0) {
              removeOverflowText($post_content, post_max_height);
            }
          }
        });

        // Prevent page change when clicking culture link on tablet landscape
        var $culture_link = $('.menu-culture > a');
        var is_touch = $('html').hasClass('touchevents');
        $culture_link.on('click', function(e) {
          if (is_touch && window.innerWidth > 959) {
            e.preventDefault();
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        var window_w;
        window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        var bg = jQuery(".slick-track");
        function resizeBackground() {
            bg.height(jQuery(window).height() + 60);
        }

        if (window_w < 768) {
          jQuery(window).resize("resizeBackground");
          resizeBackground();
        }

        // make iframe object-fit
        var Module = (function () {

          /*================ Make panel image full screen ================*/
          var setFullScreenMedia = function($target, media_ar, v_ar, v_w_original, v_h_original) {

            var _$target = $target;
            var _media_ar = media_ar;
            var _v_ar = v_ar;
            var _v_w_original = v_w_original;
            var _v_h_original = v_h_original;

            if (_v_ar === _media_ar) {
              _$target.css({
                width: _v_w_original,
                height: _v_h_original
              });
            } else if (_v_ar < _media_ar) {
              _$target.css({
                width: _v_h_original * _media_ar,
                height: _v_h_original
              });
            } else {
              _$target.css({
                width: _v_w_original,
                height: _v_w_original / _media_ar
              });
            }

          };

          /*================ Get necessary elements sizes ================*/
          var initIframe = function(v_w, v_h, $iframe) {

            var v_ar = 0,
                v_w_original = v_w,
                v_h_original = v_h,
                $target = $iframe;

            v_ar = v_w_original / v_h_original;

            var video_ar = $target.prop('width') / $target.prop('height');
            v_ar = v_w_original / v_h_original;

            setFullScreenMedia($target, video_ar, v_ar, v_w_original, v_h_original);

          };

          /*================ Public ================*/
          return {
            initIframe: initIframe
          };

        }());

        var $iframe = $('.cw-object-fit iframe');
        if ($iframe.length > 0) {
          var $v_wrapper = $('.cw-object-fit'),
              v_w,
              v_h;

          $(window).on('load', function() {
            v_w = $v_wrapper.innerWidth();
            v_h = $v_wrapper.innerHeight();
            Module.initIframe(v_w, v_h, $iframe);
          });
          $(window).smartresize(function() {
            v_w = $v_wrapper.innerWidth();
            v_h = $v_wrapper.innerHeight();
            Module.initIframe(v_w, v_h, $iframe);
            // if ( window_w > 767 && (vp_w > vp_h) ) {
            //   Module.initIframe(window_w, vp_w, vp_h, $iframe);
            // } else {
            //   $image.attr('style', '');
            //   $iframe.attr('style', '');
            //   console.info('CLEAR');
            // }
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'blog': {
      init: function() {
        // JavaScript to be fired on the blog page
        $('.filter-toggle').on('click', function() {
          $(this).toggleClass('active');
          $(".container--filter-bg").toggleClass("open");
          $(".filter-msg1--mb").toggleClass("open");

          var root = $('html, body');

          root.animate({
            scrollTop: $('.filter-toggle').offset().top
          }, 300);

          $('.overlay-filter').toggle();
        });

        // filter accordion on mobile
        var window_w;
        var $accordion = $(".js-collapse");
        var hideAccordion = function() {
          $accordion.css({display: ""});
        };
        $('.js-trigger-collapse').on('click', function() {
          if (window_w < 480 ) {
            $(this).find(".CW-chev").toggleClass("open");
            $(this).next(".js-collapse").toggle();
          }
        });

        // filter reset button positioning
        // adjust its position since msg is inline element and cannot set width
        var $filter_bar = $('.filter-bar');
        var $filter_msg = $('.filter-msg2');
        var $reset_btn = $filter_bar.find('a');
        var filter_bar_w, filter_msg_w;
        var adjustBtnPosition = function() {

          if ($reset_btn.length === 0) {
            return;
          }

          filter_bar_w = $filter_bar.outerWidth();
          // 140 for msg1
          filter_msg_w = $filter_msg.outerWidth(true) + 140;
          if (filter_bar_w < filter_msg_w) {
            $reset_btn.css({
              // msg1 + margin + padding -> 200
              left: filter_bar_w - 200,
              right: 'initial'
            });
          }
        };


        $(window).on('resize', function() {
          window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (window_w > 479 ) {
            hideAccordion();
            adjustBtnPosition();
          }
        }).trigger('resize');

      }
    },
    'tax_team': {
      init: function() {
        // JavaScript to be fired on the blog page
        $('.filter-toggle').on('click', function() {
          $(this).toggleClass('active');
          $(".container--filter-bg").toggleClass("open");
          $(".filter-msg1--mb").toggleClass("open");

          var root = $('html, body');

          root.animate({
            scrollTop: $('.filter-toggle').offset().top
          }, 300);

          $('.overlay-filter').toggle();
        });

        // filter accordion on mobile
        var window_w;
        var $accordion = $(".js-collapse");
        var hideAccordion = function() {
          $accordion.css({display: ""});
        };
        $('.js-trigger-collapse').on('click', function() {
          if (window_w < 480 ) {
            $(this).find(".CW-chev").toggleClass("open");
            $(this).next(".js-collapse").toggle();
          }
        });

        // filter reset button positioning
        // adjust its position since msg is inline element and cannot set width
        var $filter_bar = $('.filter-bar');
        var $filter_msg = $('.filter-msg2');
        var $reset_btn = $filter_bar.find('a');
        var filter_bar_w, filter_msg_w;
        var adjustBtnPosition = function() {

          if ($reset_btn.length === 0) {
            return;
          }

          filter_bar_w = $filter_bar.outerWidth();
          // 140 for msg1
          filter_msg_w = $filter_msg.outerWidth(true) + 140;
          if (filter_bar_w < filter_msg_w) {
            $reset_btn.css({
              // msg1 + margin + padding -> 200
              left: filter_bar_w - 200,
              right: 'initial'
            });
          }
        };


        $(window).on('resize', function() {
          window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (window_w > 479 ) {
            hideAccordion();
            adjustBtnPosition();
          }
        }).trigger('resize');

      }
    },
    'single_post': {
      init: function() {
        // JavaScript to be fired on single post pages
        $('.question').click(function(e) {
          $(this).next('.answer').toggle();
          $(this).toggleClass('active');
        });

        if($('.main').children().last().is('.related-posts')) {
          $('footer').addClass('no-margin');
        }
      }
    },
    'single_blog': {
      init: function() {
        // JavaScript to be fired on single post pages
        if($('.main').children().last().is('.related-posts')) {
          $('footer').addClass('no-margin');
        }
      }
    },
    'single_people': {
      init: function() {
        $(window).scroll( function(){
          /* Check the location of each desired element */
          $('.shortcode.clients').each( function(i){
            bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.6;
            bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if(bottom_of_window > bottom_of_object) {
              $(this).addClass('active');
            }
          });
        }).trigger('scroll');

        if($('.main article').first().children().last().is('.related-people')) {
          $('footer').addClass('no-margin');
        }
      }
    },
    'single_practice': {
      init: function() {
        $(window).scroll( function(){
          /* Check the location of each desired element */
          $('.shortcode.clients').each( function(i){
            bottom_of_object = $(this).offset().top + $(this).outerHeight()*0.6;
            bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if(bottom_of_window > bottom_of_object) {
              $(this).addClass('active');
            }
          });
        }).trigger('scroll');

        // JavaScript to be fired on single post pages
        $('.question').click(function(e) {
          $(this).next('.answer').toggle();
          $(this).toggleClass('active');
        });
      }
    },
    // 'post_type_archive_people': {
    //   init: function() {
    //     $('.filter-people a').click(function() {
    //         $('html, body').animate({
    //             scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top
    //         }, 300);
    //         return false;
    //     });

    //     var $trigger_dropdown = $('.js-open-filter-people'),
    //         $filter_people = $('.filter-people');

    //     var open_event;
    //     if ($('html').hasClass('touchevents')) {
    //       open_event = 'touchend';
    //     } else {
    //       open_event = 'click';
    //     }

    //     $trigger_dropdown.on(open_event, function() {
    //       $filter_people.toggleClass('is-close-mob');
    //     });

    //     function getWindowWidth() {
    //       return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    //     }

    //     $(window).on('resize', function() {
    //       if ( getWindowWidth() < 481 && $('html').hasClass('touchevents') ) {
    //         $('article.stats').remove();
    //       } else {
    //         $('.stats header').innerHeight($('article.people img').closest('article.people img').height());
    //       }

    //     }).resize();
    //     $('.js-people-container').imagesLoaded()
    //       .always( function( instance ) {
    //         $('.stats header').innerHeight($('article.people img').closest('article.people img').height());
    //         //console.log('all images loaded');
    //       });
    //   }
    // },
    'about': {
      init: function() {
        // JavaScript to be fired on about pages
        var $target,
            img_src,
            window_w;
        $(window).on('resize', function() {
          window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (window_w < 1025 ) {
            $(".shortcode.culture").each(function() {
              $target = $(this);
              img_src = $target.find("img").attr('src');
              $target.css({
                backgroundImage: "url(" + img_src + ")",
                backgroundSize: "cover",
                backgroundPosition: "center"
              });
            });
          } else {
            $(".shortcode.culture").css({
              background: ""
            });
          }
        }).trigger('resize');
      }
    },
    'post_type_archive_people': {
      init: function() {
        // JavaScript to be fired on the blog page
        $('.filter-toggle').on('click', function() {
          $(this).toggleClass('active');
          $(".container--filter-bg").toggleClass("open");
          $(".filter-msg1--mb").toggleClass("open");

          var root = $('html, body');

          root.animate({
            scrollTop: $('.filter-toggle').offset().top
          }, 300);

          $('.overlay-filter').toggle();
        });

        // filter accordion on mobile
        var window_w;
        var $accordion = $(".js-collapse");
        var hideAccordion = function() {
          $accordion.css({display: ""});
        };
        $('.js-trigger-collapse').on('click', function() {
          if (window_w < 480 ) {
            $(this).find(".CW-chev").toggleClass("open");
            $(this).next(".js-collapse").toggle();
          }
        });

        // filter reset button positioning
        // adjust its position since msg is inline element and cannot set width
        var $filter_bar = $('.filter-bar');
        var $filter_msg = $('.filter-msg2');
        var $reset_btn = $filter_bar.find('a');
        var filter_bar_w, filter_msg_w;
        var adjustBtnPosition = function() {

          if ($reset_btn.length === 0) {
            return;
          }

          filter_bar_w = $filter_bar.outerWidth();
          // 140 for msg1
          filter_msg_w = $filter_msg.outerWidth(true) + 140;
          if (filter_bar_w < filter_msg_w) {
            $reset_btn.css({
              // msg1 + margin + padding -> 200
              left: filter_bar_w - 200,
              right: 'initial'
            });
          }
        };


        $(window).on('resize', function() {
          window_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (window_w > 479 ) {
            hideAccordion();
            adjustBtnPosition();
          }
        }).trigger('resize');

      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
